// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--wzmA0","title":"a10a3f92e9--title--Ge8Ez"};